import { createAction } from '@reduxjs/toolkit'
import { QueuedSnackbarDescriptor } from '../../types'

const MODULE_NAME = 'snackbars'

export const add = createAction<QueuedSnackbarDescriptor>(
  `${MODULE_NAME}/addToQueue`
)
export const dropAll = createAction(`${MODULE_NAME}/dropQueue`)
